module.exports = __webpack_public_path__ + "static/media/Orkos_Siopis_14.f6b56919.jpg";